import React from 'react';
import Text from '../text';
import styled from '../../styled';
const NoContentContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    margin-bottom: 1.5rem;
  }

  > span + span {
    margin-top: 0.25rem;
  }
`;
export const NoResult = ({ title, text, lang, }) => {
    return (React.createElement(NoContentContainer, null,
        React.createElement("img", { alt: "", width: "200", src: "https://static.shoplineapp.com/admin/v2/img/order/pos_order_search_no_result.png" }),
        React.createElement(Text, { fontType: "Heading", lang: lang || 'en', color: "INK_600" }, title),
        React.createElement(Text, { fontType: "Body", lang: lang || 'en', color: "INK_500" }, text)));
};
export const NoSelected = ({ text, lang, }) => {
    return (React.createElement(NoContentContainer, null,
        React.createElement("img", { alt: "", width: "200", src: "https://static.shoplineapp.com/admin/v2/img/order/product_empty.svg" }),
        React.createElement(Text, { fontType: "Heading", lang: lang, color: "INK_600" }, text)));
};
//# sourceMappingURL=NoContent.js.map